<template>
	<el-button size="small"
        v-if="getFichaById(id).section.right && !getFichaById(id).section.right.static"
        @click="setFichaVisibleSection({id, section: 'right'})"
        :icon="getFichaById(id).section.right.open ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
        />
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex'
	export default {
		name: 'OpenDrawerRight',
		props: {
            id: [Number,String],
			ficha: Object
		},
        computed: {
            ...mapGetters([
				'getFichaById'
			])
        },
        methods: {
            ...mapMutations([
				'setFichaVisibleSection'
			])
        }
	}
</script>

<style lang="scss"></style>
